import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./screens/Login";
import Dashboard from "./screens/Dashboard";
import AppLayout from "./components/AppLayout";
import LabelledStockList from "./screens/LabelledStockList";
import UnlabelledStockList from "./screens/UnlabelledStockList";
import CategoryList from "./screens/CategoryList";
import ProductList from "./screens/ProductList";
import DesignList from "./screens/DesignList";
import PurityList from "./screens/PurityList";
import CreateCategory from "./screens/CreateCategory";
import CreateProduct from "./screens/CreateProduct";
import CreateDesign from "./screens/CreateDesign";
import CreatePurity from "./screens/CreatePurity";
import CreateLabelledStock from "./screens/CreateLabelledStock";
import AuthGate from "./security/AuthGate";
import NotFound from "./screens/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import StockReport from "./screens/StockReport";
import PurchaseReport from "./screens/PurchaseReport";
import SaleReport from "./screens/SaleReport";
import VendorList from "./screens/VendorList";
import CustomerList from "./screens/CustomerList";
import CreateVendor from "./screens/CreateVendor";
import CreateCustomer from "./screens/CreateCustomer";
import EmployeeList from "./screens/EmployeeList";
import CreateEmployee from "./screens/CreateEmployee";
import CompanyList from "./screens/CompanyList";
import CreateCompany from "./screens/CreateCompany";
import BranchList from "./screens/BranchList";
import CreateBranch from "./screens/CreateBranch";
import SalesList from "./screens/SalesList";
import CreateSales from "./screens/CreateSales";
import StoneList from "./screens/StoneList";
import CreateStone from "./screens/CreateStone";
import CreateUnlabelledStock from "./screens/CreateUnlabelledStock";
import UnlabelledStockReport from "./screens/UnlabelledStockReport";
import QuoteNotifications from "./screens/QuoteNotifications";
import PurchaseList from "./screens/PurchaseList";
import CreatePurchaseEntry from "./screens/CreatePurchaseEntry";
import Register from "./screens/Register";
import EditEmployee from "./screens/EditEmployee";
import EditCompany from "./screens/EditCompany";
import EditBranch from "./screens/EditBranch";
import EditCategory from "./screens/EditCategory";
import EditProduct from "./screens/EditProduct";
import EditDesign from "./screens/EditDesign";
import EditPurity from "./screens/EditPurity";
import EditLabelledStock from "./screens/EditLabelledStock";
import EditUnlabelledStock from "./screens/EditUnlabelledStock";
import StoneAttributeList from "./screens/StoneAttributeList";
import CreateStoneShape from "./screens/CreateStonShape";
import StoneShapeList from "./screens/StoneShapeList";
import StoneAttributeMasterList from "./screens/StoneAttributeMasterList";
import EditStone from "./screens/EditStone";
import LooseStoneList from "./screens/LooseStoneList";
import CreateLooseStone from "./screens/CreateLooseStone";
import EditLooseStone from "./screens/EditLooseStone";
import LooseStoneReport from "./screens/LooseStoneReport";
import CreateInvoice from "./screens/CreateInvoice";
import CreateURD from "./screens/CreateURD";
import URDGSTList from "./screens/URDGSTList";
import URDList from "./screens/URDList";
import UpdateURD from "./screens/UpdateURD";
import URDReport from "./screens/URDReport";
import UpsertCounter from "./screens/UpsertCounter";
import CounterList from "./screens/CounterList";
import CreateLooseDiamond from "./screens/CreateLooseDiamond";
import LooseDiamondList from "./screens/LooseDiamondList";
import DiamondAttributeMasterList from "./screens/DiamondAttributeMasterList";
import DiamondList from "./screens/DiamondList";
import CreateDiamond from "./screens/CreateDiamond";
import EditDiamond from "./screens/EditDiamond";
import DiamondSieveMaster from "./screens/DiamondSieveMaster";
import DiamondSizeMaster from "./screens/DiamondSizeMaster";
import EditLooseDiamond from "./screens/EditLooseDiamond";
import EditInvoice from "./screens/EditInvoice";
import EditVendor from "./screens/EditVendor";
import EditCustomer from "./screens/EditCustomer";
import TransferList from "./screens/TransferList";
import TransferCreate from "./screens/TransferCreateDualBucket";
import DepartmentList from "./screens/DepartmentList";
import CreateDepartment from "./screens/CreateDepartment";
import EditDepartment from "./screens/EditDepartment";
import RoleList from "./screens/RoleList";
import CreateRole from "./screens/CreateRole";
import EditRole from "./screens/EditRole";
import TransferCreateDualBucket from "./screens/TransferCreateDualBucket";
import ForgotPassword from "./screens/ForgotPassword";
import VerifyOtp from "./screens/VerifyOtp";
import ResetPassword from "./screens/ResetPassword";
import NotMe from "./screens/NotMe";
import RateMaster from "./screens/RateMaster";
import RateList from "./screens/RateList";
import NoAccess from "./screens/NoAccess";
import CustomerTransactionsPage from "./screens/CustomerTransactionsPage";
import LabelTemplateEditorPage from "./screens/LabelTemplateEditor";
import LabelTemplateListPage from "./screens/LabelTemplatesPage.jsx";
import SwitchInLandingPage from "./screens/SwitchInLandingPage.jsx";
import UserSpecialPermissions from "./screens/UserSpecialPermissions.jsx";
import CreateQuotation from "./screens/CreateQuotation.jsx";
import QuotationList from "./screens/QuotationList.jsx";
import EditQuotation from "./screens/EditQuotation.jsx";
import CreateGoldScheme from "./screens/CreateGoldScheme.jsx";
import GoldSchemeList from "./screens/GoldSchemeList.jsx";
import GoldSchemeEnrollmentForm from "./screens/GoldSchemeEnrollmentForm.jsx";
import GoldSchemeEnrollmentList from "./screens/GoldSchemeEnrollmentList.jsx";
import LabelledStockQrScan from "./screens/LabelledStockQrScan.jsx";
import UnlabelledTransferList from "./screens/UnlabelledTransferList.jsx";
import UnlabelledTransferCreateDualBucket from "./screens/UnlabelledTransferCreateDualBucket.jsx";
import PinGate from "./components/PinGate.jsx";
import CreateEstimate from "./screens/CreateEstimate.jsx";
import EstimateList from "./screens/EstimateList.jsx";
import SchemePayments from "./screens/SchemePayments.jsx";
import GeneralPayments from "./screens/GeneralPayments.jsx";
import InvoicePayments from "./screens/InvoicePayments.jsx";
import EditEstimate from "./screens/EditEstimate.jsx";
import ModuleFieldSettings from "./screens/ModuleFieldSettings.jsx";
import UserProfile from "./screens/UserProfile.jsx";
import InvoiceTemplateSettings from "./screens/InvoiceTemplateSettings.jsx";
import { useEffect } from "react";
import { getToken } from "firebase/messaging";
// import { messaging } from "./firebase.js";
import { getMessagingInstance } from "./firebase.js";
import { useState } from "react";
import { useSaveFcmTokenMutation } from "./toolkitServices/userApi.js";
import BankList from "./screens/BankList.jsx";
import CreateBank from "./screens/CreateBank.jsx";
import EditBank from "./screens/EditBank.jsx";
import CashFlowReport from "./screens/CashFlowReport.jsx";
import WalletReport from "./screens/WalletReport.jsx";
import DebtCreditReport from "./screens/DebtCreditReport.jsx";
import DeletedInvoiceReport from "./screens/DeletedInvoiceReport.jsx";
import GstReport from "./screens/GSTReport.jsx";
import TenantList from "./screens/TenantList.jsx";
import EnquiryList from "./screens/EnquiryList.jsx";
import TermsPage from "./screens/TermsPage.jsx";
import PrivacyPolicyPage from "./screens/PrivacyPolicyPage.jsx";
import ScrollToTop from "./components/ScrollToTop.jsx";
import SupportPage from "./screens/SupportPage.jsx";
import PricingPage from "./screens/PricingPage.jsx";
import { Toaster } from "react-hot-toast";
import StockValidation from "./screens/StockValidation.jsx";
import GstReturnReport from "./screens/GstReturnReport.jsx";
import OtherSettings from "./screens/OtherSettings.jsx";
import PrnLabelTemplateEditorPage from "./screens/PrnLabelTemplateEditorPage.jsx";
import PrnLabelTemplateListPage from "./screens/PrnLabelTemplateListPage.jsx";
import CreateRfidMaster from "./screens/CreateRfidMaster.jsx";
import RfidMasterList from "./screens/RfidMasterList.jsx";
import EditRfidMaster from "./screens/EditRfidMaster.jsx";
import WhatsAppSetup from "./screens/WhatsAppSetup.jsx";
import WhatsAppCatalog from "./screens/WhatsAppCatalog.jsx";
import WhatsAppOrders from "./screens/WhatsAppOrders.jsx";
import InvoiceTemplateList from "./screens/InvoiceTemplateList.jsx";
import UrdTemplateSettings from "./screens/UrdTemplateSettings.jsx";
import PublicInvoicePage from "./screens/PublicInvoicePage.jsx";
import EstimateTemplateList from "./screens/EstimateTemplateList.jsx";
import QuotationTemplateList from "./screens/QuotationTemplateList.jsx";
import EstimateTemplateSettings from "./screens/EstimateTemplateSettings.jsx";
import PublicEstimatePage from "./screens/PublicEstimatePage.jsx";
import LuxuryBrochurePage from "./screens/LuxuryBrochurePage.jsx";
import QuotationTemplateSettings from "./screens/QuotationTemplateSettings.jsx";
import PublicQuotationPage from "./screens/PublicQuotationPage.jsx";
import UrdTemplateList from "./screens/UrdTemplateList.jsx";
import ReceiptTemplateList from "./screens/ReceiptTemplateList.jsx";
import ReceiptTemplateSettings from "./screens/ReceiptTemplateSettings.jsx";
import PublicReceiptView from "./screens/PublicReceiptView.jsx";
import AIMarketingPostGenerator from "./screens/AIMarketingPostGenerator.jsx";
import EmployeeForgotPassword from "./screens/EmployeeForgotPassword.jsx";
import DailyRateMessage from "./screens/DailyRateMessage.jsx";

const App = () => {
  const [saveFcmToken] = useSaveFcmTokenMutation();

  // useEffect(() => {
  //   const initFCM = async () => {
  //     try {
  //       if (typeof window === "undefined" || !("Notification" in window)) return;

  //       const messaging = await getMessagingInstance();
  //       if (!messaging) return;

  //       const permission = await Notification.requestPermission();
  //       if (permission !== "granted") return;

  //       const token = await getToken(messaging, {
  //         vapidKey:
  //           "BFQK7NvjDqG3vsOuOUqLWD8luvj6VAAX7M6KTXr-j4DSRtkR6gUanomOYjEe7n54Rc2js4DWJS-SxFrvUENCGdg",
  //       });

  //       if (token) {
  //         await saveFcmToken(token);
  //       }
  //     } catch (error) {
  //       console.error("FCM init failed:", error);
  //     }
  //   };

  //   initFCM();
  // }, [saveFcmToken]);

  const ESTIMATE_PIN_KEY = "estimate_bundle"; // one key for both screens

  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* <Toaster
  position="top-right"
  gutter={12}
  containerStyle={{
    top: 20,
    right: 20,
  }}
  toastOptions={{
    duration: 3500,
    style: {
      background: "transparent",
      boxShadow: "none",
      padding: 0,
    },
  }}
/> */}
      <Toaster position="top-right" />

      <Routes>
        {/* ✅ Public routes (no auth needed) */}
        <Route path="/invoice/public/:token" element={<PublicInvoicePage />} />
        <Route
          path="/quotation/public/:token"
          element={<PublicQuotationPage />}
        />
        <Route
          path="/estimate/public/:token"
          element={<PublicEstimatePage />}
        />
        <Route path="/receipt/public/:token" element={<PublicReceiptView />} />
        <Route path="/brochure/:slug" element={<LuxuryBrochurePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/employee-forgot-password"
          element={<EmployeeForgotPassword />}
        />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/not-me" element={<NotMe />} />
        <Route path="/register" element={<Register />} />
        {/* <Route path="/admin/tenant-list" element={<TenantList />} /> */}
        <Route path="/no-access" element={<NoAccess />} />
        {/* <Route path="/no-access" element={<NoAccess />} /> */}
        <Route path="/" element={<SwitchInLandingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/pricing" element={<PricingPage />} />

        {/* ✅ Protected routes go inside AuthGate + ProtectedRoute */}
        <Route
          path="/*"
          element={
            <AuthGate>
              <Routes>
                <Route
                  element={
                    <ProtectedRoute moduleKey="dashboard" action="view" />
                  }
                >
                  <Route
                    path="/dashboard"
                    element={
                      <AppLayout componentType="dashboard">
                        <Dashboard />
                      </AppLayout>
                    }
                  />
                </Route>
                {/* <Route element={<ProtectedRoute moduleKey="dashboard" action="view" />}>
 
                  <Route
                    path="/settings/notifications"
                    element={
                      <AppLayout componentType="dashboard">
                        <QuoteNotifications />
                      </AppLayout>
                    }
                  />
                   </Route>  */}
                {/* <Route
                  element={<ProtectedRoute moduleKey="invoice" action="view" />}
                >
                  <Route
                    path="/admin/tenant-list"
                    element={
                      <AppLayout componentType="sales">
                        <TenantList />
                      </AppLayout>
                    }
                  />
                </Route> */}

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/tenant-list"
                    element={
                      <AppLayout componentType="admin">
                        <TenantList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/enquiry-list"
                    element={
                      <AppLayout componentType="admin">
                        <EnquiryList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="invoice" action="view" />}
                >
                  <Route
                    path="/sales/sales-list"
                    element={
                      <AppLayout componentType="sales">
                        <SalesList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="invoice" action="create" />
                  }
                >
                  <Route
                    path="/sales/sales-list/create-sale"
                    element={
                      <AppLayout componentType="sales">
                        <CreateInvoice />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="invoice" action="edit" />}
                >
                  <Route
                    path="/sales/sales-list/:id/edit"
                    element={
                      <AppLayout componentType="sales">
                        <EditInvoice />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="purchase" action="view" />
                  }
                >
                  <Route
                    path="/purchase/urd-gst-list"
                    element={
                      <AppLayout componentType="purchase">
                        <URDList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="purchase" action="create" />
                  }
                >
                  <Route
                    path="/purchase/urd-gst-list/create-urd"
                    element={
                      <AppLayout componentType="purchase">
                        <CreateURD />
                      </AppLayout>
                    }
                  />
                </Route>
                {/* <Route
                  element={
                    <ProtectedRoute moduleKey="invoice" action="create" />
                  }
                >
                  <Route
                    path="/sales/sales-list/create-sale"
                    element={
                      <AppLayout componentType="sales">
                        <CreateSales />
                      </AppLayout>
                    }
                  />
                </Route> */}
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="view" />}
                >
                  <Route
                    path="/stocks/labelled-stock-list"
                    element={
                      <AppLayout componentType="stocks">
                        <LabelledStockList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="edit" />}
                >
                  <Route
                    path="/stocks/labelled-stock-list/edit/:id"
                    element={
                      <AppLayout componentType="stocks">
                        <EditLabelledStock />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="create" />}
                >
                  <Route
                    path="/stocks/labelled-stock-list/create-labelled-stock"
                    element={
                      <AppLayout componentType="stocks">
                        <CreateLabelledStock />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="purchase" action="view" />
                  }
                >
                  <Route
                    path="/purchase/purchase-stock-list"
                    element={
                      <AppLayout componentType="purchase">
                        <PurchaseList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="purchase" action="create" />
                  }
                >
                  <Route
                    path="/purchase/purchase-stock-list/create-purchase"
                    element={
                      <AppLayout componentType="purchase">
                        <CreatePurchaseEntry />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="purchase" action="edit" />
                  }
                >
                  <Route
                    path="/purchase/purchase-stock-list/update-purchase/:id"
                    element={
                      <AppLayout componentType="purchase">
                        <UpdateURD />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="view" />}
                >
                  <Route
                    path="/stocks/unlabelled-stock-list"
                    element={
                      <AppLayout componentType="stocks">
                        <UnlabelledStockList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="create" />}
                >
                  <Route
                    path="/stocks/unlabelled-stock-list/create-unlabelled-stock"
                    element={
                      <AppLayout componentType="stocks">
                        <CreateUnlabelledStock />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="edit" />}
                >
                  <Route
                    path="/stocks/unlabelled-stock-list/edit/:id"
                    element={
                      <AppLayout componentType="stocks">
                        <EditUnlabelledStock />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="view" />}
                >
                  <Route
                    path="/stocks/loose-stones"
                    element={
                      <AppLayout componentType="stocks">
                        <LooseStoneList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="create" />}
                >
                  <Route
                    path="/stocks/loose-stones/create"
                    element={
                      <AppLayout componentType="stocks">
                        <CreateLooseStone />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="edit" />}
                >
                  <Route
                    path="/stocks/loose-stones/:id/edit"
                    element={
                      <AppLayout componentType="stocks">
                        <EditLooseStone />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="view" />}
                >
                  <Route
                    path="/stocks/loose-diamonds"
                    element={
                      <AppLayout componentType="stocks">
                        <LooseDiamondList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="create" />}
                >
                  <Route
                    path="/stocks/loose-diamonds/create"
                    element={
                      <AppLayout componentType="stocks">
                        <CreateLooseDiamond />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="stock" action="edit" />}
                >
                  <Route
                    path="/stocks/loose-diamonds/:id/edit"
                    element={
                      <AppLayout componentType="stocks">
                        <EditLooseDiamond />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="category master" action="view" />
                  }
                >
                  <Route
                    path="/masters/category-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <CategoryList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="category master"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/masters/category-master-list/new-category"
                    element={
                      <AppLayout componentType="masters">
                        <CreateCategory />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="category master" action="edit" />
                  }
                >
                  <Route
                    path="/masters/category-master-list/:id/edit"
                    element={
                      <AppLayout componentType="masters">
                        <EditCategory />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="product master" action="view" />
                  }
                >
                  <Route
                    path="/masters/product-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <ProductList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="product master"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/masters/product-master-list/new-product"
                    element={
                      <AppLayout componentType="masters">
                        <CreateProduct />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="product master" action="edit" />
                  }
                >
                  <Route
                    path="/masters/product-master-list/:id/edit"
                    element={
                      <AppLayout componentType="masters">
                        <EditProduct />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="design master" action="view" />
                  }
                >
                  <Route
                    path="/masters/design-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <DesignList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="design master" action="create" />
                  }
                >
                  <Route
                    path="/masters/design-master-list/new-design"
                    element={
                      <AppLayout componentType="masters">
                        <CreateDesign />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="design master" action="edit" />
                  }
                >
                  <Route
                    path="/masters/design-master-list/:id/edit"
                    element={
                      <AppLayout componentType="masters">
                        <EditDesign />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="purity master" action="view" />
                  }
                >
                  <Route
                    path="/masters/purity-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <PurityList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="purity master" action="create" />
                  }
                >
                  <Route
                    path="/masters/purity-master-list/new-purity"
                    element={
                      <AppLayout componentType="masters">
                        <CreatePurity />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="purity master" action="edit" />
                  }
                >
                  <Route
                    path="/masters/purity-master-list/:id/edit"
                    element={
                      <AppLayout componentType="masters">
                        <EditPurity />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="stone master" action="view" />
                  }
                >
                  <Route
                    path="/masters/stone-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <StoneList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="diamond master" action="view" />
                  }
                >
                  <Route
                    path="/masters/diamond-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <DiamondList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="diamond master"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/masters/diamond-master-list/new-diamond"
                    element={
                      <AppLayout componentType="masters">
                        <CreateDiamond />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="diamond master" action="edit" />
                  }
                >
                  <Route
                    path="/masters/diamond-master-list/:id"
                    element={
                      <AppLayout componentType="masters">
                        <EditDiamond />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="attribute master"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/masters/stone-attribute-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <StoneAttributeMasterList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="attribute master"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/masters/diamond-attribute-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <DiamondAttributeMasterList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="other master" action="view" />
                  }
                >
                  <Route
                    path="/masters/diamond-sieve-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <DiamondSieveMaster />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="other master" action="view" />
                  }
                >
                  <Route
                    path="/masters/diamond-size-master-list"
                    element={
                      <AppLayout componentType="masters">
                        <DiamondSizeMaster />
                      </AppLayout>
                    }
                  />
                </Route>

                {/* <Route
                  path="/masters/stone-shape-list"
                  element={
                    <AppLayout componentType="masters">
                      <StoneShapeList />
                    </AppLayout>
                  }
                />
                <Route
                  path="/masters/stone-shape-list/create"
                  element={
                    <AppLayout componentType="masters">
                      <CreateStoneShape />
                    </AppLayout>
                  }
                /> */}
                <Route
                  element={
                    <ProtectedRoute moduleKey="stone master" action="create" />
                  }
                >
                  <Route
                    path="/masters/stone-master-list/new-stone"
                    element={
                      <AppLayout componentType="masters">
                        <CreateStone />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="stone master" action="edit" />
                  }
                >
                  <Route
                    path="/masters/stone-master-list/:id"
                    element={
                      <AppLayout componentType="masters">
                        <EditStone />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="stock Report" action="view" />
                  }
                >
                  <Route
                    path="/reports/stock-report"
                    element={
                      <AppLayout componentType="reports">
                        <StockReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="stock Report" action="view" />
                  }
                >
                  <Route
                    path="/reports/unlabelled-stock-report"
                    element={
                      <AppLayout componentType="reports">
                        <UnlabelledStockReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="urd report" action="view" />
                  }
                >
                  <Route
                    path="/reports/urd-report"
                    element={
                      <AppLayout componentType="reports">
                        <URDReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="stock Report" action="view" />
                  }
                >
                  <Route
                    path="/reports/loose-stone-stock-report"
                    element={
                      <AppLayout componentType="reports">
                        <LooseStoneReport />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="sale report" action="view" />
                  }
                >
                  <Route
                    path="/reports/sale-report"
                    element={
                      <AppLayout componentType="reports">
                        <SaleReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="company" action="view" />}
                >
                  <Route
                    path="/organisation/company-master-list"
                    element={
                      <AppLayout componentType="organisation">
                        <CompanyList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="company" action="create" />
                  }
                >
                  <Route
                    path="/organisation/company-master-list/new-company"
                    element={
                      <AppLayout componentType="organisation">
                        <CreateCompany />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="company" action="edit" />}
                >
                  <Route
                    path="/organisation/company-master-list/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <EditCompany />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="branch" action="view" />}
                >
                  <Route
                    path="/organisation/branch-master-list"
                    element={
                      <AppLayout componentType="organisation">
                        <BranchList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="department" action="view" />
                  }
                >
                  <Route
                    path="/organisation/department-master-list"
                    element={
                      <AppLayout componentType="organisation">
                        <DepartmentList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="role" action="view" />}
                >
                  <Route
                    path="/organisation/role-master-list"
                    element={
                      <AppLayout componentType="organisation">
                        <RoleList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="role" action="create" />}
                >
                  <Route
                    path="/organisation/role-master-list/new-role"
                    element={
                      <AppLayout componentType="organisation">
                        <CreateRole />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="role" action="edit" />}
                >
                  <Route
                    path="/organisation/role-master-list/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <EditRole />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="department" action="create" />
                  }
                >
                  <Route
                    path="/organisation/department-list/new-department"
                    element={
                      <AppLayout componentType="organisation">
                        <CreateDepartment />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="department" action="edit" />
                  }
                >
                  <Route
                    path="/organisation/department-list/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <EditDepartment />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="branch" action="create" />
                  }
                >
                  <Route
                    path="/organisation/branch-master-list/new-branch"
                    element={
                      <AppLayout componentType="organisation">
                        <CreateBranch />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="branch" action="edit" />}
                >
                  <Route
                    path="/organisation/branch-master-list/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <EditBranch />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="counter" action="view" />}
                >
                  <Route
                    path="/organisation/counter-master-list"
                    element={
                      <AppLayout componentType="organisation">
                        <CounterList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="counter" action="create" />
                  }
                >
                  <Route
                    path="/organisation/counter-master-list/new-counter"
                    element={
                      <AppLayout componentType="organisation">
                        <UpsertCounter />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="counter" action="edit" />}
                >
                  <Route
                    path="/organisation/counter-master-list/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <UpsertCounter />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="vendor" action="view" />}
                >
                  <Route
                    path="/members/vendor-list"
                    element={
                      <AppLayout componentType="members">
                        <VendorList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="vendor" action="create" />
                  }
                >
                  <Route
                    path="/members/vendor-list/create-vendor"
                    element={
                      <AppLayout componentType="members">
                        <CreateVendor />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="vendor" action="edit" />}
                >
                  <Route
                    path="/members/vendor-list/:id/edit"
                    element={
                      <AppLayout componentType="members">
                        <EditVendor />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="customer" action="view" />
                  }
                >
                  <Route
                    path="/members/customer-list"
                    element={
                      <AppLayout componentType="members">
                        <CustomerList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="customer" action="create" />
                  }
                >
                  <Route
                    path="/members/customer-list/create-customer"
                    element={
                      <AppLayout componentType="members">
                        <CreateCustomer />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="customer" action="edit" />
                  }
                >
                  <Route
                    path="/members/customer-list/:id/edit"
                    element={
                      <AppLayout componentType="members">
                        <EditCustomer />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="rate master" action="view" />
                  }
                >
                  <Route
                    path="/masters/daily-rate-list"
                    element={
                      <AppLayout componentType="masters">
                        <RateList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="rate master" action="view" />
                  }
                >
                  <Route
                    path="/masters/daily-rate-list/daily-rate"
                    element={
                      <AppLayout componentType="masters">
                        <RateMaster />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="stock transfers" action="view" />
                  }
                >
                  <Route
                    path="/transfers"
                    element={
                      <AppLayout componentType="transfer">
                        <TransferList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="stock transfers"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/transfers/create"
                    element={
                      <AppLayout componentType="transfer">
                        <TransferCreateDualBucket />
                        {/* <TransferCreate /> */}
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="employee" action="view" />
                  }
                >
                  <Route
                    path="/members/employee-list"
                    element={
                      <AppLayout componentType="members">
                        <EmployeeList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="employee" action="create" />
                  }
                >
                  <Route
                    path="/members/employee-list/create-employee"
                    element={
                      <AppLayout componentType="members">
                        <CreateEmployee />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="employee" action="edit" />
                  }
                >
                  <Route
                    path="/members/employee-list/:id/edit"
                    element={
                      <AppLayout componentType="members">
                        <EditEmployee />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="customer transaction"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/transactions/customer"
                    element={
                      <AppLayout componentType="transactions">
                        <CustomerTransactionsPage />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="label editor" action="view" />
                  }
                >
                  <Route
                    path="/designs/label/List"
                    element={
                      <AppLayout componentType="designs">
                        <LabelTemplateListPage />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="label editor" action="edit" />
                  }
                >
                  <Route
                    path="/designs/label/:id/edit"
                    element={
                      <AppLayout componentType="designs">
                        <LabelTemplateEditorPage />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="label editor" action="create" />
                  }
                >
                  <Route
                    path="/designs/label"
                    element={
                      <AppLayout componentType="designs">
                        <LabelTemplateEditorPage />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="user Management"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/user-management/special-permissions/:employeeId"
                    element={
                      <AppLayout componentType="user management">
                        <UserSpecialPermissions />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="quotation" action="view" />
                  }
                >
                  <Route
                    path="/quotations/quotation-list"
                    element={
                      <AppLayout componentType="quotations">
                        <QuotationList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="quotation" action="create" />
                  }
                >
                  <Route
                    path="/quotations/quotation-list/create-quotation"
                    element={
                      <AppLayout componentType="quotations">
                        <CreateQuotation />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="quotation" action="edit" />
                  }
                >
                  <Route
                    path="/quotations/quotation-list/:id/edit"
                    element={
                      <AppLayout componentType="quotations">
                        <EditQuotation />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="scheme" action="view" />}
                >
                  <Route
                    path="/scheme/gold-scheme"
                    element={
                      <AppLayout componentType="scheme">
                        <GoldSchemeList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="scheme" action="create" />
                  }
                >
                  <Route
                    path="/scheme/gold-scheme/create"
                    element={
                      <AppLayout componentType="scheme">
                        <CreateGoldScheme />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="scheme enrollment"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/scheme/gold-scheme/enroll"
                    element={
                      <AppLayout componentType="scheme">
                        <GoldSchemeEnrollmentList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="scheme enrollment"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/scheme/gold-scheme/enroll/new"
                    element={
                      <AppLayout componentType="scheme">
                        <GoldSchemeEnrollmentForm />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="item detail" action="view" />
                  }
                >
                  <Route
                    path="/stocks/labelled-stock-scan"
                    element={
                      <AppLayout componentType="">
                        <LabelledStockQrScan />
                      </AppLayout>
                    }
                  />
                </Route>
                {/* <Route
                  element={
                    <ProtectedRoute moduleKey="stock transfers" action="view" />
                  }
                > */}
                <Route
                  element={
                    <ProtectedRoute moduleKey="stock transfers" action="view" />
                  }
                >
                  <Route
                    path="/transfers/unlabelled-transfers"
                    element={
                      <AppLayout componentType="transfer">
                        <UnlabelledTransferList />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="stock transfers"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/transfers/unlabelled-transfers/create"
                    element={
                      <AppLayout componentType="transfer">
                        <UnlabelledTransferCreateDualBucket />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="estimate" action="view" />
                  }
                >
                  {/* <Route
                  element={<PinGate pinKey={ESTIMATE_PIN_KEY} ttlMinutes={10} />}
                  > */}
                  <Route
                    path="/estimate/estimate-list"
                    element={
                      <AppLayout componentType="estimate">
                        <EstimateList />
                      </AppLayout>
                    }
                  />
                  {/* </Route> */}
                </Route>

                {/* <Route
                  element={
                    <ProtectedRoute moduleKey="estimate" action="create" />
                  }
                > */}

                <Route
                  element={
                    <ProtectedRoute moduleKey="estimate" action="create" />
                  }
                >
                  <Route
                    path="/estimate/estimate-list/create-estimate"
                    element={
                      <AppLayout componentType="estimate">
                        <CreateEstimate />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="estimate" action="edit" />
                  }
                >
                  <Route
                    path="/estimate/estimate-list/:id/edit"
                    element={
                      <AppLayout componentType="estimate">
                        <EditEstimate />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="customer transaction"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/transactions/customer/schemes-transaction"
                    element={
                      <AppLayout componentType="transactions">
                        <SchemePayments />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="customer transaction"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/transactions/customer/general"
                    element={
                      <AppLayout componentType="transactions">
                        <GeneralPayments />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="customer transaction"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/transactions/customer/invoice-transaction"
                    element={
                      <AppLayout componentType="transactions">
                        <InvoicePayments />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/labelled-module-fields"
                    element={
                      <AppLayout componentType="settings">
                        <ModuleFieldSettings />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/unlabelled-module-fields"
                    element={
                      <AppLayout componentType="settings">
                        <ModuleFieldSettings module="UNLABELLED_STOCK" />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/invoice-module-fields"
                    element={
                      <AppLayout componentType="settings">
                        <ModuleFieldSettings module="INVOICE_FIELDS" />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/urd-module-fields"
                    element={
                      <AppLayout componentType="settings">
                        <ModuleFieldSettings module="URD_FIELDS" />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/invoice-template"
                    element={
                      <AppLayout componentType="settings">
                        <InvoiceTemplateSettings module="URD_FIELDS" />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="profile" action="view" />}
                >
                  <Route
                    path="/profile"
                    element={
                      <AppLayout componentType="profile">
                        <UserProfile />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="bank" action="view" />}
                >
                  <Route
                    path="/organisation/bank-master-list"
                    element={
                      <AppLayout componentType="organisation">
                        <BankList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="bank" action="create" />}
                >
                  <Route
                    path="/organisation/bank-master-list/new-bank"
                    element={
                      <AppLayout componentType="organisation">
                        <CreateBank />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="bank" action="edit" />}
                >
                  <Route
                    path="/organisation/bank-master-list/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <EditBank />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="cash report" action="view" />
                  }
                >
                  <Route
                    path="/reports/cash-report"
                    element={
                      <AppLayout componentType="reports">
                        <CashFlowReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="wallet report" action="view" />
                  }
                >
                  <Route
                    path="/reports/wallet-report"
                    element={
                      <AppLayout componentType="reports">
                        <WalletReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="o/s report" action="view" />
                  }
                >
                  <Route
                    path="/reports/cre-debt-report"
                    element={
                      <AppLayout componentType="reports">
                        <DebtCreditReport />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="deleted invoice report"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/reports/deleted-invoices-report"
                    element={
                      <AppLayout componentType="reports">
                        <DeletedInvoiceReport />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={
                    <ProtectedRoute moduleKey="gst report" action="view" />
                  }
                >
                  <Route
                    path="/reports/gst-report"
                    element={
                      <AppLayout componentType="reports">
                        <GstReport />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="purchase report" action="view" />
                  }
                >
                  <Route
                    path="/reports/purchase-report"
                    element={
                      <AppLayout componentType="reports">
                        <PurchaseReport />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="stock verification"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/stock-validation"
                    element={
                      <AppLayout componentType="stock-verification">
                        <StockValidation />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="gst return report"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/reports/gst-return-report"
                    element={
                      <AppLayout componentType="reports">
                        <GstReturnReport />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/est-template"
                    element={
                      <AppLayout componentType="settings">
                        <EstimateTemplateSettings />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/quotation-template"
                    element={
                      <AppLayout componentType="settings">
                        <QuotationTemplateSettings />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/urd-template"
                    element={
                      <AppLayout componentType="settings">
                        <UrdTemplateSettings />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="setting" action="create" />
                  }
                >
                  <Route
                    path="/settings/receipt-template-settings"
                    element={
                      <AppLayout componentType="settings">
                        <ReceiptTemplateSettings />
                      </AppLayout>
                    }
                  />
                </Route>
                <Route
                  element={<ProtectedRoute moduleKey="setting" action="view" />}
                >
                  <Route
                    path="/settings/other-settings"
                    element={
                      <AppLayout componentType="settings">
                        <OtherSettings />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="label editor" action="create" />
                  }
                >
                  <Route
                    path="/designs/prn-label-templates/new"
                    element={
                      <AppLayout componentType="designs">
                        <PrnLabelTemplateEditorPage />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="label editor" action="edit" />
                  }
                >
                  <Route
                    path="/designs/prn-label-templates/edit/:id"
                    element={
                      <AppLayout componentType="designs">
                        <PrnLabelTemplateEditorPage />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute moduleKey="label editor" action="view" />
                  }
                >
                  <Route
                    path="/designs/prn-label-templates/list"
                    element={
                      <AppLayout componentType="designs">
                        <PrnLabelTemplateListPage />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="rfid" action="create" />}
                >
                  <Route
                    path="/organisation/rfid-master/create"
                    element={
                      <AppLayout componentType="organisation">
                        <CreateRfidMaster />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="rfid" action="edit" />}
                >
                  <Route
                    path="/organisation/rfid-master/:id/edit"
                    element={
                      <AppLayout componentType="organisation">
                        <EditRfidMaster />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={<ProtectedRoute moduleKey="rfid" action="view" />}
                >
                  <Route
                    path="/organisation/rfid-master/list"
                    element={
                      <AppLayout componentType="organisation">
                        <RfidMasterList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="whatsapp commerce"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/whatsapp/setup"
                    element={
                      <AppLayout componentType="whatsapp-commerce">
                        <WhatsAppSetup />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="whatsapp commerce"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/whatsapp/catalog"
                    element={
                      <AppLayout componentType="whatsapp-commerce">
                        <WhatsAppCatalog />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      moduleKey="whatsapp commerce"
                      action="create"
                    />
                  }
                >
                  <Route
                    path="/whatsapp/orders"
                    element={
                      <AppLayout componentType="whatsapp-commerce">
                        <WhatsAppOrders />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/invoice-templates"
                    element={
                      <AppLayout componentType="admin">
                        <InvoiceTemplateList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/receipt-templates"
                    element={
                      <AppLayout componentType="admin">
                        <ReceiptTemplateList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/est-templates"
                    element={
                      <AppLayout componentType="admin">
                        <EstimateTemplateList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/quotation-template"
                    element={
                      <AppLayout componentType="admin">
                        <QuotationTemplateList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                  element={
                    <ProtectedRoute
                      adminOnly={true}
                      moduleKey="admin"
                      action="view"
                    />
                  }
                >
                  <Route
                    path="/admin/urd-template"
                    element={
                      <AppLayout componentType="admin">
                        <UrdTemplateList />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                // element={
                //    <ProtectedRoute
                //       adminOnly={true}
                //       moduleKey="admin"
                //       action="view"
                //     />
                // }
                >
                  <Route
                    path="/marketing/ai-post-generator"
                    element={
                      <AppLayout componentType="marketing">
                        <AIMarketingPostGenerator />
                      </AppLayout>
                    }
                  />
                </Route>

                <Route
                // element={
                //    <ProtectedRoute
                //       adminOnly={true}
                //       moduleKey="admin"
                //       action="view"
                //     />
                // }
                >
                  <Route
                    path="/marketing/daily-rate-message"
                    element={
                      <AppLayout componentType="marketing">
                        <DailyRateMessage/>
                      </AppLayout>
                    }
                  />
                </Route>

                

                {/* Catch-all inside protected area */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AuthGate>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
